export default [
  {
    path: '/settings/return-reason-types',
    name: 'return-reason-type-list',
    component: () => import('@/views/settings/ReturnReasonTypes.vue'),
    meta: {
      pageTitle: 'Motif de retour',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Motif de retour', active: true },
      ],
      requiresAdmin: true,
    },
  },
  {
    path: '/settings/parameters',
    name: 'parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres',
      breadcrumb: [
        { text: 'Paramètres', active: true },
      ],
      roles: ['admin', 'superadmin', 'admin_developer'],
      requireLogin: true,
    },
  },
  {
    path: '/settings/parameters/banners',
    name: 'dashboard-banner-parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres Bannières',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Bannières', active: true },
      ],
      roles: ['admin', 'superadmin'],
      requireLogin: true,
    },
  },
  {
    path: '/settings/parameters/supplier-bordereau-display',
    name: 'supplier-bordereau-display-parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres Bordereaux',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Bordereaux fournisseur', active: true },
      ],
      roles: ['admin', 'superadmin'],
      requireLogin: true,
    },
  },
  {
    path: '/settings/parameters/delivery-note-print-note',
    name: 'delivery-note-print-note-parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Note impression bordereaux',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Note bordereaux', active: true },
      ],
      roles: ['admin', 'superadmin'],
      requireLogin: true,
    },
  },
  {
    path: '/settings/parameters/inventory',
    name: 'inventory-parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres Inventaire',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Inventaire', active: true },
      ],
      roles: ['admin', 'superadmin'],
      requireLogin: true,
    },
  },
  {
    path: '/settings/parameters/roadmaps',
    name: 'roadmap-print-parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres Run sheets',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Run sheets', active: true },
      ],
      roles: ['admin', 'superadmin'],
      requireLogin: true,
    },
  },
  {
    path: '/settings/parameters/company-bordereau-display',
    name: 'company-bordereau-display-parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres Bordereaux Société',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Bordereaux société', active: true },
      ],
      roles: ['admin_developer'],
      requireLogin: true,
    },
  },
]
